import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import ContactModal from "../components/ContactModal";
import AboutModal from "../components/AboutModal";
import CookieBanner from "../components/CookieBanner";
import Navbar from "../components/Navbar";
import { track } from "../utils/tracking";
import { getProducts, resetCache } from "../utils/productCache";

const Home = () => {
  const navigate = useNavigate();

  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // 🔥 Estado para el texto de búsqueda

  useEffect(() => {
    track("page_view", {
      page_name: "home"
    });

    const init = async () => {
      try {
        resetCache();
        await getProducts();
        console.log("✅ cache inicializado");
      } catch (err) {
        console.error("Error inicializando cache:", err);
      }
    };

    init();
  }, []);

  // 🔥 Función para manejar la búsqueda al presionar Enter
  const handleSearch = (e) => {
    if (e.key === "Enter" && searchTerm.trim() !== "") {
      track("search_submit", { query: searchTerm });
      // Redirigimos a la ruta de productos pasando el término de búsqueda
      // Nota: Asegúrate de que tu App.js tenga una ruta que reciba este parámetro
      navigate(`/menu_prod/search?q=${encodeURIComponent(searchTerm.trim())}`);
    }
  };

  return (
    <div className="industrial-site">

      <CookieBanner />

      {/* HEADER */}
      <header className="header">
        <div
          className="logo-section"
          onClick={() => {
            track("click_logo");
            navigate("/");
          }}
        >
          <img
            src="fiori_logo-Photoroom.png"
            alt="Fiori"
            className="logo-img"
          />
        </div>
      </header>

      {/* SEARCH MODIFICADO */}
      <div className="search-section">
        <input
          type="text"
          placeholder="Buscar productos y presionar Enter..."
          className="search-bar"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)} // Actualiza el estado
          onKeyDown={handleSearch} // Detecta la tecla Enter
          onFocus={() => track("search_focus")}
        />
      </div>

      {/* NAVBAR */}
      <Navbar onOpenContact={() => setIsContactOpen(true)} />

      {/* HERO */}
      <section className="hero">
        <div
          className="hero-bg"
          style={{ backgroundImage: "url('/fiori_fondo.png')" }}
        ></div>

        <h2>Floristeria y Eventos</h2>

        <button
          onClick={() => {
            track("click_about");
            setIsAboutOpen(true);
          }}
        >
          Conocer más
        </button>

        <div className="water-mark">
          <p className="subtitle">Decora tus espacios con conciencia</p>
        </div>

        <p>
          Conecta con la belleza de tu interior para generar lazos fuertes.
        </p>
      </section>

      {/* PRODUCTOS INFO */}
      <main className="product-grid">
        <div>
          <h3>Misión</h3>
          <p>
            Compartir la sabiduría que encontramos en la vida a través de las flores y del arte de dar, creando experiencias que transmitan emociones reales y generen impacto en las personas.
          </p>
        </div>

        <div>
          <h3>Visión</h3>
          <p>
            Aportar al cambio de la sociedad, construyendo un mundo donde los detalles tengan significado y estén guiados por la belleza, la intención y la claridad.
          </p>
        </div>
      </main>

      {/* FOOTER */}
      <footer className="footer">
        <p>© 2026 FIORI floristería y eventos.</p>
      </footer>

      {/* MODAL CONTACTO */}
      <ContactModal
        isOpen={isContactOpen}
        onClose={() => setIsContactOpen(false)}
      />

      {/* MODAL SOBRE NOSOTROS */}
      <AboutModal 
        isOpen={isAboutOpen} 
        onClose={() => setIsAboutOpen(false)} 
      />

    </div>
  );
};

export default Home;